/**
 * @file Contains helper functions for no results in assignment
 */
import { ComposeNodeType } from '../../../../../containers/compose/props';
import translate from '../../../../../i18n/translate';
import { SearchListType } from '../types';

import { Reason } from './types';

/**
 * Mapping between no result reason and the translations key
 */
const commonMapping: Record<Reason, string> = {
  empty: 'GENERAL__RESULTS__EMPTY_MESSAGE',
  fetching: 'GENERAL__PLEASE_WAIT',
  searching: 'GENERAL__RESULTS__EMPTY_MESSAGE',
};

/**
 * Mapping between search list type and no result translation keys
 */
const mapping: Record<SearchListType, Record<Reason, string>> = {
  groups: { ...commonMapping, empty: 'GROUPS__EMPTY_MESSAGE' },
  labels: commonMapping,
  members: commonMapping,
};

/**
 * Get the message to show, explaining why there's nothing to show
 *
 * @param reason The reason we want the message for
 * @param type   The type of the list (members/groups/labels)
 * @returns      The (translated) message
 */
export const getMessage = (reason: Reason, type: SearchListType): string => {
  return translate(mapping[type][reason]);
};

/**
 * Get translation key for no items
 *
 * @param nodeType Is it used for messages or templates (or labels if no nodeType)
 * @returns        Translation key
 */
export const getNoItemsTranslationKey = (nodeType?: ComposeNodeType) => {
  if (nodeType === undefined) {
    return 'LABELS__EMPTY_MESSAGE';
  }

  return nodeType === 'MESSAGE'
    ? 'ASSIGNMENT__GENERAL__NO_RESULTS'
    : 'ASSIGNMENT__GENERAL__NO_RESULTS_TOPIC';
};
